/*
 * ******************************************************************
 * Copyright (c) 2024-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component, EventEmitter, Input, Output } from "@angular/core";

// @formatter:off
@Component({
    standalone: false,
    selector: "info-card",
    templateUrl: "./info-card.component.html",
    styleUrls: ["./info-card.component.scss"],
    host: {'class': 'clr-radio-wrapper'}
})
// @formatter:on
export class InfoCardComponent {

    @Input()
    public id: string;

    @Input()
    public name: string;

    @Input()
    public label: string;

    @Input()
    public icon: string;

    @Input()
    public description: string;

    @Input()
    public infoText: string;

    @Output()
    public modelChange: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }
}
